import { render } from "./PlayAudio.vue?vue&type=template&id=58c054ae"
import script from "./PlayAudio.vue?vue&type=script&lang=js"
export * from "./PlayAudio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__